import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import productSlice from "../features/productSlice";
import cartSlice from "../features/cartSlice";
import categorySlice from "../features/categorySlice";
import wishlistSlice from "../features/wishlistSlice";
import orderSlice from "../features/orderSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    product: productSlice,
    cart: cartSlice,
    category: categorySlice,
    wishlist: wishlistSlice,
    order: orderSlice,
    // Add other reducers here
  },
});

export default store;
